// Copyright (c) 2016 Deere & Company

import DealerAccountsFacet, {getDefaultState as getDealerAccountsFacetDefaultState} from '../../../shared/state/dealer-accounts-facet';
import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const LaborAdditiveFacets = t.struct({
    dealerAccountsFacet: DealerAccountsFacet,
    showExcludedFacet: t.struct({
        allowedExcluded: t.list(KeyValuePair),
        isInitialLoad: t.Boolean,
        selectedExcluded: KeyValuePair
    })
}, 'LaborAdditiveFacets');

export const getDefaultState = () =>
    new LaborAdditiveFacets({
        dealerAccountsFacet: getDealerAccountsFacetDefaultState(),
        showExcludedFacet: {
            allowedExcluded: [],
            isInitialLoad: true,
            selectedExcluded: getKeyValueDefaultState()
        }
    });

export default LaborAdditiveFacets;



// WEBPACK FOOTER //
// ./src/pip/labor-additive/state/facets.js